import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountSentimentReportAverageSummaryAggregateRootMapper } from '../../../infrastructure/mappers/sentiment/account-sentiment-report-average-summary-aggregate-root.mapper';
import { GetAccountSentimentReportAverageSummaryRequestDto } from '../../dtos/sentiment/get-account-sentiment-report-average-summary.request.dto';
import { GetAccountSentimentReportAverageSummaryResponseDto } from '../../dtos/sentiment/get-account-sentiment-report-average-summary.response.dto';
import { GetAccountSentimentReportAverageSummaryQuery } from '../../queries/sentiment/get-account-sentiment-report-average-summary.query';

export class GetAccountSentimentReportAverageSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountSentimentReportAverageSummaryQuery,
    protected readonly mapper: AccountSentimentReportAverageSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountSentimentReportAverageSummaryRequestDto
  ): Promise<GetAccountSentimentReportAverageSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountSentimentReportAverageSummaryController.get encountered an error ${error}`
      );
    }
  }
}
